import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { NoShowToastContext } from "src/app/core/interceptors/http-toast.interceptor";
import { environment } from "src/environments/environment";
import { normalizeBillingServiceOverview } from "./billing-service-overview.mapper";
import {
  BillingServiceOverview,
  BillingServiceOverviewApiResponse,
} from "./billing-service-overview.model";

@Injectable({
  providedIn: "root",
})
export class BillingServiceOverviewService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.baseApiUrl}/billing`;

  getServiceOverview(): Observable<BillingServiceOverview> {
    return this.http
      .get<BillingServiceOverviewApiResponse>(`${this.baseUrl}/service-overview`, {
        ...NoShowToastContext(),
      })
      .pipe(
        map((response) => normalizeBillingServiceOverview(response)),
        catchError((error) => throwError(() => error)),
      );
  }
}
